<div class="services container" [dir]="language == 'ar' ? 'rtl' : 'ltr'">
  <div>
    <h3>
      {{ data.details.title.split(" ")[0] }}
      <span> {{ data.details.title.split(" ")[1] }}</span>
    </h3>

    <div class="d-flex cards-container">
      <div
        class="card"
        *ngFor="let service of data.details.services"
        [ngClass]="{ 'no-hover': !data.details.isDetails }"
      >
        <div class="col">
          <a
            [href]="data.details.isDetails ? getLink(service) : null"
            style="text-decoration: none"
          >
            <app-service-card
              [cardTitle]="service.titleTr"
              [cardIcon]="icons[service.icon]"
              [imgPath]="service.imageIconPath"
              [language]="language"
            ></app-service-card>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
